import { inject, NgModule } from '@angular/core';
import { PreloadAllModules, Router, RouterModule, Routes } from '@angular/router';
import { redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { AuthGuard } from './guards/auth.guard';



const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['pages/tabs/tab2']);

//export const redirectUnauthorizedToLogin = () => {
//  const router = inject(Router); // Use inject() to get the Router service
//  return () => {
//    router.navigate(['pages/tabs/tab2']); // Perform the redirection
//  };
//};

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'create-questions/:modul',
    loadChildren: () => import('./pages/create-questions/create-questions.module').then( m => m.CreateQuestionsPageModule),
    //canActivate: [AngularFireAuthGuard], data: { authGuardPipe:  redirectUnauthorizedToLogin}
    //canMatch: [() => inject(AuthGuard).canAccess()]  
    canActivate: [AuthGuard]

  },
  {
    path: 'edit-question/:modul/:id',
    loadChildren: () => import('./pages/edit-question/edit-question.module').then( m => m.EditQuestionPageModule),
    ///canActivate: [AngularFireAuthGuard], data: { authGuardPipe:  redirectUnauthorizedToLogin}
    //canMatch: [() => inject(AuthGuard).canAccess()] 
    canActivate: [AuthGuard]
  },
  {
    path: 'practice-questions/:modul',
    loadChildren: () => import('./pages/practice-questions/practice-questions.module').then( m => m.PracticeQuestionsPageModule),
    ///canActivate: [AngularFireAuthGuard], data: { authGuardPipe:  redirectUnauthorizedToLogin}
    //canMatch: [() => inject(AuthGuard).canAccess()] 
    canActivate: [AuthGuard]
  },
  {
    path: 'review-questions/:modul',
    loadChildren: () => import('./pages/review-questions/review-questions.module').then( m => m.ReviewQuestionsPageModule),
    ///canActivate: [AngularFireAuthGuard], data: { authGuardPipe:  redirectUnauthorizedToLogin}
    //canMatch: [() => inject(AuthGuard).canAccess()] 
    canActivate: [AuthGuard]
  },
  {
    path: 'messages',
    loadChildren: () => import('./pages/messages/messages.module').then( m => m.MessagesPageModule),
    ///canActivate: [AngularFireAuthGuard], data: { authGuardPipe:  redirectUnauthorizedToLogin}
    //canMatch: [() => inject(AuthGuard).canAccess()] 
    canActivate: [AuthGuard]
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
